import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { LAYER, useSmartClosePopups } from 'js/components/common/PopupManager';

import { useLogout } from '../../useLogout';
import { VALIDATION_TYPE } from '../constants';
import { useContinueLogin } from './useContinueLogin';
import { useValidationManager } from './useValidationManager';
import { showPinVerificationPopupAction } from 'js/components/popups/PinVerificationPopup';

export const useValidatePin = (validationsRef) => {
    const logout = useLogout();
    const dispatch = useDispatch();
    const continueLogin = useContinueLogin();
    const closePopups = useSmartClosePopups();
    const {
        validationStart, validationDone, isValidationInProcess, areAllValidationsDone
    } = useValidationManager(VALIDATION_TYPE.PIN_VERIFICATION, validationsRef);

    return useCallback((pasLoginResponse, credentials, options = {}) => {
        const { sessionValidationData = {} } = pasLoginResponse?.data || {};

        if (!sessionValidationData.SessionValidationByPinData) {
            validationDone();

            return;
        }

        if (isValidationInProcess()) {
            return;
        }

        let ensureLogout = true;
        const { isSSO } = options;

        validationStart();

        dispatch(showPinVerificationPopupAction({
            id: VALIDATION_TYPE.PIN_VERIFICATION,
            isSSO,
            onSuccess: async () => {
                validationDone();

                if (areAllValidationsDone()) {
                    await continueLogin({ credentials, ...options });
                }

                ensureLogout = false;
            },
            onClose: async () => {
                if (ensureLogout) {
                    await logout();

                    closePopups({ excludeLayers: [LAYER.LOGIN] });
                }
            }
        }));
    }, [closePopups, logout, continueLogin, dispatch, validationStart,
        validationDone, isValidationInProcess, areAllValidationsDone]);
};
